export default __webpack_public_path__ + "static/media/crees2.3e071c04.jpg";